// extracted by mini-css-extract-plugin
module.exports = {"Popup":"Popup_Popup__-g9_Y","popUpBack":"Popup_popUpBack__2Rt8M","InnerPopup":"Popup_InnerPopup__2MZwC","popUpLand":"Popup_popUpLand__3qk_d","PopUpClose":"Popup_PopUpClose__2Yz_z"};